import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { themes } from "../Styling/themeConfigs";

import { Spacings } from "@/styling/spacings";

type Props = {
  text: string;
};

const currentTheme = themes.morning;

function NoteCard({ text }: Props): React.JSX.Element {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignSelf: "stretch",
    paddingHorizontal: Spacings.s4,
    paddingVertical: Spacings.s2,
    borderRadius: Spacings.s3,
    marginBottom: Spacings.s3,
    backgroundColor: "rgba(0, 0, 0, 0.03)",
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.05)",
  },
  text: {
    fontSize: currentTheme.typography.body.size.mobile + 1,
    color: currentTheme.typography.body.color,
    lineHeight:
      (currentTheme.typography.body.size.mobile + 1) *
      currentTheme.typography.body.lineHeight,
  },
});

export default NoteCard;
